module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABaSURBVChTY8AHVq1axTx79mxNKBc/ACmeNWvWIqCGWVAh3ABJ8Rogmw0qjB3QTjEIgNxLtGIQAJreDtRwYObMmVxQIcIAqKF38GtaAuUSB6ZNmyYIZQIBAwMA05lOR/F3x58AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/left_arrow.png
// module id = 7
// module chunks = 0